@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import cc.bluepeak.clubmanager.site.components.layouts.PageLayout as _cc_bluepeak_clubmanager_site_components_layouts_PageLayout
import cc.bluepeak.clubmanager.site.pages.Calendar as _cc_bluepeak_clubmanager_site_pages_Calendar
import cc.bluepeak.clubmanager.site.pages.Contact as _cc_bluepeak_clubmanager_site_pages_Contact
import cc.bluepeak.clubmanager.site.pages.Downloads as _cc_bluepeak_clubmanager_site_pages_Downloads
import cc.bluepeak.clubmanager.site.pages.Help as _cc_bluepeak_clubmanager_site_pages_Help
import cc.bluepeak.clubmanager.site.pages.Index as _cc_bluepeak_clubmanager_site_pages_Index
import cc.bluepeak.clubmanager.site.pages.Invoicing as _cc_bluepeak_clubmanager_site_pages_Invoicing
import cc.bluepeak.clubmanager.site.pages.MemberAdministration as _cc_bluepeak_clubmanager_site_pages_MemberAdministration
import cc.bluepeak.clubmanager.site.pages.Register as _cc_bluepeak_clubmanager_site_pages_Register
import cc.bluepeak.clubmanager.site.pages.SquadManagement as _cc_bluepeak_clubmanager_site_pages_SquadManagement

public fun main() {
    AppGlobals.initialize(mapOf("title" to "ClubManager"))
    BasePath.set("/en/")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "cc.bluepeak.clubmanager.site.components.layouts.PageLayout",
        ) { pageCtx, pageMethod -> 
            _cc_bluepeak_clubmanager_site_components_layouts_PageLayout(pageCtx) {
                pageMethod(pageCtx)
            }
        }
        ctx.router.register(
            "/",
            layoutId = "cc.bluepeak.clubmanager.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                cc.bluepeak.clubmanager.site.pages.initIndex(ctx)
            },
        ) { pageCtx -> 
            _cc_bluepeak_clubmanager_site_pages_Index()
        }
        ctx.router.register(
            "/calendar",
            layoutId = "cc.bluepeak.clubmanager.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                cc.bluepeak.clubmanager.site.pages.initCalendar(ctx)
            },
        ) { pageCtx -> 
            _cc_bluepeak_clubmanager_site_pages_Calendar()
        }
        ctx.router.register(
            "/contact",
            layoutId = "cc.bluepeak.clubmanager.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                cc.bluepeak.clubmanager.site.pages.initContact(ctx)
            },
        ) { pageCtx -> 
            _cc_bluepeak_clubmanager_site_pages_Contact()
        }
        ctx.router.register(
            "/downloads",
            layoutId = "cc.bluepeak.clubmanager.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                cc.bluepeak.clubmanager.site.pages.initDownloads(ctx)
            },
        ) { pageCtx -> 
            _cc_bluepeak_clubmanager_site_pages_Downloads()
        }
        ctx.router.register(
            "/help",
            layoutId = "cc.bluepeak.clubmanager.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                cc.bluepeak.clubmanager.site.pages.initHelp(ctx)
            },
        ) { pageCtx -> 
            _cc_bluepeak_clubmanager_site_pages_Help()
        }
        ctx.router.register(
            "/invoicing",
            layoutId = "cc.bluepeak.clubmanager.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                cc.bluepeak.clubmanager.site.pages.initInvoicing(ctx)
            },
        ) { pageCtx -> 
            _cc_bluepeak_clubmanager_site_pages_Invoicing()
        }
        ctx.router.register(
            "/member-administration",
            layoutId = "cc.bluepeak.clubmanager.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                cc.bluepeak.clubmanager.site.pages.initMemberAdministration(ctx)
            },
        ) { pageCtx -> 
            _cc_bluepeak_clubmanager_site_pages_MemberAdministration()
        }
        ctx.router.register(
            "/register",
            layoutId = "cc.bluepeak.clubmanager.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                cc.bluepeak.clubmanager.site.pages.initRegister(ctx)
            },
        ) { pageCtx -> 
            _cc_bluepeak_clubmanager_site_pages_Register()
        }
        ctx.router.register(
            "/squad-management",
            layoutId = "cc.bluepeak.clubmanager.site.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                cc.bluepeak.clubmanager.site.pages.initSquadManagement(ctx)
            },
        ) { pageCtx -> 
            _cc_bluepeak_clubmanager_site_pages_SquadManagement()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("card", cc.bluepeak.clubmanager.site.styles.CardStyle)
        ctx.theme.registerStyle("padded-card", cc.bluepeak.clubmanager.site.styles.PaddedCardStyle)
        ctx.theme.registerStyle("secondary-card", cc.bluepeak.clubmanager.site.styles.SecondaryCardStyle)
        ctx.theme.registerStyle("secondary-paragraph", cc.bluepeak.clubmanager.site.styles.SecondaryParagraph)
        ctx.theme.registerStyle("underlined-text-area", cc.bluepeak.clubmanager.site.styles.UnderlinedTextAreaStyle)
        ctx.theme.registerStyle("drop-down", cc.bluepeak.clubmanager.site.styles.DropDownStyle)
        ctx.theme.registerStyle("feature-image-card", cc.bluepeak.clubmanager.site.components.sections.FeatureImageCardStyle)
        ctx.theme.registerStyle("mobile-menu", cc.bluepeak.clubmanager.site.components.layouts.MobileMenuStyle)
        ctx.theme.registerStyle("desktop-menu", cc.bluepeak.clubmanager.site.components.layouts.DesktopMenuStyle)
        ctx.theme.registerStyle("nav-header", cc.bluepeak.clubmanager.site.components.layouts.NavHeaderStyle)
        ctx.theme.registerStyle("nav-header-wrapper", cc.bluepeak.clubmanager.site.components.layouts.NavHeaderWrapperStyle)
        ctx.theme.registerStyle("nav-header-link", cc.bluepeak.clubmanager.site.components.layouts.NavHeaderLinkStyle)
        ctx.theme.registerStyle("mobile-menu-overlay", cc.bluepeak.clubmanager.site.components.layouts.MobileMenuOverlayStyle)
        ctx.theme.registerStyle("mobile-menu-box", cc.bluepeak.clubmanager.site.components.layouts.MobileMenuBoxStyle)
        ctx.theme.registerStyle("page", cc.bluepeak.clubmanager.site.components.layouts.PageStyle)
        ctx.theme.registerStyle("panel", cc.bluepeak.clubmanager.site.components.widgets.PanelStyle)
        ctx.theme.registerStyle("demo-link", cc.bluepeak.clubmanager.site.components.widgets.DemoLinkStyle)
        ctx.theme.registerStyle("sticky-section", cc.bluepeak.clubmanager.site.pages.stickySectionStyle)
        ctx.theme.registerStyle("dynamic-download-card", cc.bluepeak.clubmanager.site.pages.DynamicDownloadCard)
        ctx.theme.registerVariant("-underlined", cc.bluepeak.clubmanager.site.styles.UnderlinedInputVariant)
        ctx.theme.registerVariant("-nav", cc.bluepeak.clubmanager.site.styles.NavLinkVariant)
        ctx.theme.registerVariant("-button", cc.bluepeak.clubmanager.site.styles.ButtonLinkVariant)
        ctx.theme.registerVariant("-secondary-button", cc.bluepeak.clubmanager.site.styles.SecondaryButtonLinkVariant)
        ctx.theme.registerVariant("-circle", cc.bluepeak.clubmanager.site.components.widgets.CircleButtonVariant)
        ctx.theme.registerVariant("-uncolored", cc.bluepeak.clubmanager.site.components.widgets.UncoloredButtonVariant)
        ctx.theme.registerVariant("-field-tag-style", cc.bluepeak.clubmanager.site.components.widgets.FieldTagStyle)
        ctx.theme.registerKeyframes("mobile-menu-animations", cc.bluepeak.clubmanager.site.components.layouts.MobileMenuAnimations)
        ctx.theme.registerKeyframes("panel", cc.bluepeak.clubmanager.site.components.widgets.PanelKeyframes)
        ctx.theme.registerKeyframes("panel-reverse", cc.bluepeak.clubmanager.site.components.widgets.PanelReverseKeyframes)
        cc.bluepeak.clubmanager.site.styles.initStyleSheet(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        cc.bluepeak.clubmanager.site.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
